import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function PolicyIcon(props: IconProps) {
    return <Icon {...props} iconKey={"policy"}/>
}
